import * as CL from '@design-system/component-library';
import { invoiceDeliveryMethodMsg, invoiceLanguageMsg, t } from '../../../common/i18n/index.js';
import { Dropdown } from '../../../common/react-hook-form/components/Dropdown.js';
import { Language } from '../../../common/react-hook-form/fields/Language.js';
import { GridColumn } from '../../BillingAccountDetails/components/GridColumn.js';
import type { CLDropdownItem } from '../../../common/types/componentLibrary';
import type { BillingAccountDeliveryMethod } from '../../../generated/api/models.js';

export const DeliveryMethodAndLanguageSelection = ({
  deliveryMethodOptions,
  setDeliveryType,
}: {
  deliveryMethodOptions: CLDropdownItem[];
  setDeliveryType: (deliveryType: BillingAccountDeliveryMethod) => void;
}) => {
  return (
    <CL.GridRow>
      <GridColumn className="of-billing-account-details form-column edit-field">
        <Dropdown
          name="deliveryMethod"
          id="deliveryMethod"
          items={deliveryMethodOptions}
          label={t.H272(invoiceDeliveryMethodMsg)}
          onValueChange={value => {
            if (value) {
              setDeliveryType(value as BillingAccountDeliveryMethod);
            }
          }}
        />
      </GridColumn>
      <GridColumn className="of-billing-account-details form-column edit-field">
        <Language name="billLanguage" label={t.A7DR(invoiceLanguageMsg)} />
      </GridColumn>
    </CL.GridRow>
  );
};
